import { PdpRespRingSize_item as Item } from './__generated__/PdpRespRingSize_item.graphql';

import { FC, useState } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { createFragmentContainer, graphql, RelayProp } from 'react-relay/legacy';
import { PdpSharedRingSizeDetail } from '../PdpSharedRingSize/PdpSharedRingSizeDetail';
import { PdpSharedRingSizeGuideModalLazy } from '../PdpSharedRingSize/PdpSharedRingSizeGuideModalLazy';
import { PdpSharedRingSizeGuideModalLink } from '../PdpSharedRingSize/PdpSharedRingSizeGuideModalLink';
import RingIcon from 'dibs-icons/exports/PlaceholderJewelry';
import styles from './PdpRespRingSize.scss';

type Props = {
    isClient: boolean;
    item: Item;
    relay: RelayProp;
};

export const messages = defineMessages({
    ringSizeLabel: {
        id: 'pdp.ringSizeLabel',
        defaultMessage: 'Ring Size',
    },
});

export const PdpRespRingSizeComponent: FC<Props> = ({ isClient, item, relay }) => {
    const intl = useIntl();
    const [modalOpen, setModalOpen] = useState(false);
    const ringSizeLabel = intl.formatMessage(messages.ringSizeLabel);
    const detailValues: $TSFixMe =
        item?.pdpDetailsDisplay?.find(detail => detail?.detailKey === 'RING_SIZE')?.detailValues ||
        [];

    return detailValues.length ? (
        <div className={styles.wrapper}>
            <div className={styles.icon}>
                <RingIcon />
            </div>
            <div className={styles.text}>
                <span className={styles.label}>{ringSizeLabel}: </span>
                <span data-tn="ring-size">
                    <PdpSharedRingSizeDetail detailValues={detailValues} />
                </span>{' '}
                <PdpSharedRingSizeGuideModalLink onClick={() => setModalOpen(true)} />
                {isClient && (
                    <PdpSharedRingSizeGuideModalLazy
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        relay={relay}
                    />
                )}
            </div>
        </div>
    ) : null;
};

export const PdpRespRingSize = createFragmentContainer(PdpRespRingSizeComponent, {
    item: graphql`
        fragment PdpRespRingSize_item on Item {
            pdpDetailsDisplay {
                detailKey
                detailValues {
                    ...PdpSharedRingSizeDetail_detailValues
                }
            }
        }
    `,
});
